import { useHasBillingManagementActive } from '@ibk/shared-config';
import { FeatureFlagUseCase } from '@ibk/shared-types';
import { useFeatureFlag } from '../useFeatureFlag/useFeatureFlag';
export const useNFSeAccess = (isAuthenticated) => {
    const { isFeatureFlagWhiteListed, isLoading: isLoadingFeatureFlags } = useFeatureFlag(undefined, {
        isLoggedIn: isAuthenticated,
    });
    const isNFSeModuleEnabled = !!isFeatureFlagWhiteListed(FeatureFlagUseCase.MODULE_BILLING_NFSE);
    const { hasBillingActive: hasBillingManagementActive, isLoading: isLoadingBillingManagementActive } = useHasBillingManagementActive();
    const canAccessNFSe = isNFSeModuleEnabled && hasBillingManagementActive;
    const isLoadingAccess = isLoadingFeatureFlags || isLoadingBillingManagementActive;
    const shouldRedirectFromNFSe = !isLoadingAccess && !canAccessNFSe;
    return {
        isNFSeModuleEnabled,
        hasBillingManagementActive,
        isLoadingFeatureFlags,
        isLoadingBillingManagementActive,
        canAccessNFSe,
        shouldRedirectFromNFSe,
    };
};
